import { useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import PriceRibbon from "../components/PriceRibbon";
import Marquee from "../components/Marquee";
import WhyJoin from "../components/WhyJoin";
import Project from "../components/Project";
import Residences from "../components/Residences";
import WellnessClub from "../components/WellnessClub";
import Neighborhood from "../components/Neighborhood";
import AboutMarlene from "../components/AboutMarlene";
import PriorityForm from "../components/PriorityForm";
import ContactStrip from "../components/ContactStrip";
import Footer from "../components/Footer";
import AccessGate from "../components/AccessGate";

const LandingPage = () => {
  const [unlocked, setUnlocked] = useState(() => localStorage.getItem("gate_done") === "1");

  if (!unlocked) return <AccessGate onUnlock={() => setUnlocked(true)} />;

  return (
    <div className="grain" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <PriceRibbon />
        <Marquee />
        <WhyJoin />
        <Project />
        <Residences />
        <WellnessClub />
        <Neighborhood />
        <AboutMarlene />
        <PriorityForm />
        <ContactStrip />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
